module.exports = __webpack_public_path__ + "static/the-road-less-traveled-885ae8766d7b11bca6722f2c4625a2ef.jpg";